import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-end-block',
  imports: [RouterLink],
  templateUrl: './end-block.html',
  styleUrl: './end-block.scss',
})
export class EndBlock {

}
